var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-card',[_c('app-menu',{attrs:{"menus":_vm.menus,"homeUrl":_vm.homeUrl}}),_c('router-view',{staticClass:"container-principal",attrs:{"name":"content"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }